import type { PatternFormFieldItem } from '@ricoh/ria.client.core/types/component/pattern.type';
import type { RecordKey } from '@ricoh/ria.client.core/types/core/data.type';

import type { PatternOutput } from '~/common/model/api/batch-type/pattern';

/** Create Pattern Output. */
export const createPatternOutput = {
  output: (value: string): PatternOutput => ({
    $is: 'output',
    name: value,
  }),
};

/** Create Pattern Output FormField. */
export const createPatternOutputFormField = {
  output: <TTabKey extends RecordKey>(tabKey: TTabKey, pattern: PatternOutput): PatternFormFieldItem<TTabKey> => ({
    $is: 'tag',
    tabKey,
    value: pattern.name,
  }),
};
